import type { Audience, Channel, DesiredTone, EmojiPreference, Mode } from "../types/api";

type ContextFieldsProps = {
  mode: Mode;
  open: boolean;
  onToggle: () => void;
  channel: Channel;
  audience: Audience;
  desiredTone: DesiredTone;
  emojiPreference: EmojiPreference;
  disabled?: boolean;
  onChannelChange: (value: Channel) => void;
  onAudienceChange: (value: Audience) => void;
  onDesiredToneChange: (value: DesiredTone) => void;
  onEmojiPreferenceChange: (value: EmojiPreference) => void;
};

const communicationChannels: Array<{ value: Channel; label: string }> = [
  { value: "unspecified", label: "infer" },
  { value: "text", label: "text" },
  { value: "email", label: "email" },
  { value: "group_chat", label: "group chat" },
  { value: "work_chat", label: "work chat" },
  { value: "social_post", label: "social post" },
  { value: "dating_app", label: "dating app" },
  { value: "other", label: "other" }
];

const behaviorAudiences: Array<{ value: Audience; label: string }> = [
  { value: "unspecified", label: "unspecified" },
  { value: "friend", label: "friends" },
  { value: "date", label: "date" },
  { value: "family", label: "family" },
  { value: "coworker", label: "coworkers" },
  { value: "public", label: "public" }
];

const communicationAudiences: Array<{ value: Audience; label: string }> = [
  { value: "unspecified", label: "unspecified" },
  { value: "friend", label: "friend" },
  { value: "date", label: "date" },
  { value: "family", label: "family" },
  { value: "coworker", label: "coworker" },
  { value: "manager", label: "manager" },
  { value: "client", label: "client" },
  { value: "public", label: "public" },
  { value: "other", label: "other" }
];

const tones: Array<{ value: DesiredTone; label: string }> = [
  { value: "keep_voice", label: "keep my voice" },
  { value: "warmer", label: "warmer" },
  { value: "shorter", label: "shorter" },
  { value: "more_casual", label: "more casual" },
  { value: "more_professional", label: "more professional" },
  { value: "more_playful", label: "more playful" }
];

const emojiOptions: Array<{ value: EmojiPreference; label: string }> = [
  { value: "auto", label: "auto" },
  { value: "none", label: "none" },
  { value: "light", label: "light" },
  { value: "more", label: "more" }
];

export function ContextFields(props: ContextFieldsProps) {
  const audiences = props.mode === "behavior" ? behaviorAudiences : communicationAudiences;

  return (
    <div className="context-wrap">
      <button
        type="button"
        className="text-button"
        onClick={props.onToggle}
        aria-expanded={props.open}
        disabled={props.disabled}
      >
        {props.open ? "hide context" : "add context"}
      </button>
      {props.open ? (
        <div className="context-grid">
          {props.mode === "communication" ? (
            <label>
              <span>Channel</span>
              <select
                value={props.channel}
                disabled={props.disabled}
                onChange={(event) => props.onChannelChange(event.target.value as Channel)}
              >
                {communicationChannels.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </label>
          ) : null}
          <label>
            <span>Audience</span>
            <select
              value={props.audience}
              disabled={props.disabled}
              onChange={(event) => props.onAudienceChange(event.target.value as Audience)}
            >
              {audiences.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
          {props.mode === "communication" ? (
            <>
              <label>
                <span>Desired rewrite</span>
                <select
                  value={props.desiredTone}
                  disabled={props.disabled}
                  onChange={(event) => props.onDesiredToneChange(event.target.value as DesiredTone)}
                >
                  {tones.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                <span>Emoji</span>
                <select
                  value={props.emojiPreference}
                  disabled={props.disabled}
                  onChange={(event) => props.onEmojiPreferenceChange(event.target.value as EmojiPreference)}
                >
                  {emojiOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </label>
            </>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
